var account = "Compte";
var accountSettings = "Paramètres du compte";
var charging = "Chargement";
var contactInfo = "Coordonnées";
var dashboard = "Tableau de bord";
var home = "Accueil";
var myProducts = "Mes produits";
var orderHistory = "Historique des commandes";
var paymentMethod = "Méthode de paiement";
var profileSettings = "Paramètres du profil";
var referAndEarn = "Référez et gagnez";
var signOut = "Déconnexion";
var fr_CA = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, fr_CA as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
